<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Creating a User File</h3>
    <table>
      <tbody>
        <tr>
          <td>
            <p class="NOTE">
              Perhaps you want to update the points of all the users at one or more locations, but you don't want to have to enter all that data into
              an access database or a spreadsheet. In that case, you can simply create an access database or excel spreadsheet that is pre-populated
              with all the users from a particular location or locations. To do so, simply select from the list of locations in the select box at the
              top. Remember to hold down the control key to click on multiple locations or to "de-select" a location. You may also select "all users"
              if you want to get all of your users into the file.
            </p>
            <div></div>
            <p class="note">Next, select the type of file you wish to create - either an access db file or an excel file.</p>
            <div>
              <div></div>
              <p class="note" align="left">
                Finally, click on the <input type="button" value="Build New User File" class="btn btn-primary btn-lg btn-sm-block mr-2" /> button. A
                new file with users from your chosen company will be created on the server for you to download. You will see a link immediately below
                the button to <a class="text" href="/admin-points-faq/previous-files">download</a> your new file.
              </p>

              <br />
              <br /><br />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'Create',
};
</script>
<style scoped>
table {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
.btn .btn-primary {
  margin: 0px !important;
}
</style>
